import ApproachPillars from "@/components/sections/ApproachPillars";
import ClosingCTA from "@/components/sections/ClosingCTA";

const TIMELINE = [
    { wk: "Week 0", t: "Discovery & Baseline", d: "Comprehensive intake, lab requisitions, body composition, cardio-metabolic mapping. We meet you where you are." },
    { wk: "Weeks 1–2", t: "Protocol Design", d: "Personalised, executable plan — nutrition, movement, sleep, stress, connection. We co-design with you, not at you." },
    { wk: "Weeks 3–8", t: "Active Reversal / Optimisation", d: "Weekly check-ins, wearable signal review, micro-adjustments. Most measurable shifts begin here." },
    { wk: "Weeks 9–12", t: "Re-test & Recalibrate", d: "Repeat biomarkers, refine protocol, transition to maintenance cadence or annual partnership." },
    { wk: "Beyond", t: "Continuity", d: "Quarterly reviews for reversal patients · annual deep dives for longevity partners." },
];

export default function ApproachPage() {
    return (
        <>
            <section className="ihx-warm-surface ihx-grid-overlay">
                <div className="ihx-container py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-8">
                        <span className="ihx-eyebrow">The Approach</span>
                        <h1 className="ihx-h-display mt-5">
                            How a typical patient moves from baseline to <span className="ihx-italic">reversal.</span>
                        </h1>
                    </div>
                    <p className="lg:col-span-4 ihx-lead">
                        The arc is consistent. The protocol is yours alone. Below is the
                        rhythm most patients follow over their first 12 weeks.
                    </p>
                </div>
            </section>

            <ApproachPillars />

            <section
                style={{
                    background:
                        "radial-gradient(60% 80% at 10% 50%, hsl(var(--brand-gold-soft) / 0.5) 0%, transparent 55%), hsl(var(--bg-chalk))",
                }}
            >
                <div className="ihx-container py-20 lg:py-28">
                    <span className="ihx-eyebrow">A 12-week rhythm</span>
                    <h2 className="ihx-h-section mt-5 max-w-2xl">
                        Predictable structure. <span className="ihx-italic">Personalised</span> content.
                    </h2>
                    <div className="mt-12 grid grid-cols-1 md:grid-cols-5 gap-4">
                        {TIMELINE.map((s, i) => (
                            <div key={s.t} className="ihx-card p-6 md:p-7 flex flex-col">
                                <span className="font-serif italic text-[26px] text-[hsl(var(--brand-gold))] leading-none">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span className="text-[11px] tracking-[0.22em] uppercase text-[hsl(var(--ink-muted))] mt-3">
                                    {s.wk}
                                </span>
                                <div className="font-serif text-[18px] text-[hsl(var(--brand-ink-deep))] mt-2 leading-tight">
                                    {s.t}
                                </div>
                                <p className="text-[13px] text-[hsl(var(--ink-soft))] mt-3 leading-[1.65]">
                                    {s.d}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <ClosingCTA />
        </>
    );
}
